import $ from 'jquery';
import { confirmAlert } from 'react-confirm-alert';
import pluralize from 'pluralize';

$(function () {
  if (!$('.js-companies-form').length) {
    return;
  }

  $('.js-help').click(function () {
    $(this).parents('.form-group').find('.js-help-text').toggleClass('hidden');
  });

  $('[data-toggle="tooltip"]').tooltip();

  var originalChannels = $('.channel-selection:checked');

  $('#channel-update').click(function (e) {
    var currentChannels = $('.channel-selection:checked');
    var channelsChanged =
      $(originalChannels).not(currentChannels).length !== 0 ||
      $(currentChannels).not(originalChannels).length !== 0;

    if (currentChannels.length == 1 && channelsChanged) {
      if (
        !window.confirm(
          'All team members will have ' +
            $(currentChannels[0]).attr('value') +
            ' activated. Are you sure?',
        )
      ) {
        e.preventDefault();
      }
    }
  });

  $('.js-disabled-channel-clicker').click(function () {
    $('.js-disabled-channel-clicker-message').removeClass('hidden');
  });

  $('input.js-test-email').change(function () {
    var href = $('.js-provision-api').attr('href').split('?')[0];
    if (href) {
      var testEmail = $('input.js-test-email').val();
      $('.js-provision-api').attr(
        'href',
        href + '?test_email=' + encodeURIComponent(testEmail),
      );
    }
  });

  $('body.companies.new .js-company-name').change(function () {
    $('.js-from-suffix').val('from ' + this.value);
  });

  function saveCompanyFeature(checkboxElement, value) {
    var $featureContainer = $(checkboxElement).closest('[data-company-feature]'),
      feature = $featureContainer.data('company-feature'),
      url = $featureContainer.data('url');

    $('.text-success.js-saved').remove();

    $.ajax({
      url: url,
      type: 'PUT',
      data: { company_feature: feature, value: value },
      success: function () {
        var $message = $('<span class="text-success js-saved"> Saved!</span>');
        $featureContainer.find('.bootstrap-switch-square').append($message);
        $message.fadeOut(2000, function () {
          $(this).remove();
        });
      },
    });
  }

  $('div[data-company-feature] [data-toggle="switch"]').on(
    'switchChange.bootstrapSwitch',
    function (e, value) {
      saveCompanyFeature(this, value);
    }
  );

  $('.js-product-toggle [data-toggle="switch"]').on('switchChange.bootstrapSwitch', function () {
    var $parentEl = $(this).closest('.js-product');
    var $productFeatures = $('.js-product-features input', $parentEl);

    if ($(this).is(':checked')) {
      $productFeatures.attr('disabled', false);
    } else {
      $productFeatures.attr('disabled', true);
    }
  });

  $('#external_surveys[data-toggle="switch"]').on('change', function () {
    const value = $(this).is(':checked');

    if (value) {
      saveCompanyFeature(this, value);
    } else {
      const showExternalSurveysConfirmAlert = (showWarning, allIncompleteCount, error) => confirmAlert({
        title: 'Disable Bring Your Own Survey?',
        childrenElement: () => (
          <div id="js-profiles-info">
            <div className="margin-top-small">
              The following profile values are required to send surveys via Agent Connect:
                <ul style={{ listStyle: 'inherit' }} className="margin-left-large margin-top-small">
                  <li className="text-black">Image</li>
                  <li className="text-black">State or country</li>
                  <li className="text-black">Bio</li>
                </ul>
            </div>
            {showWarning
              ? (
                <div className="background-light-yellow padding-large rounded-medium">
                  <span><b>Incomplete profiles:</b> {allIncompleteCount} incomplete {pluralize('profile', allIncompleteCount)} detected.</span>
                  <div>
                    Use the <a href="/admin/bulk_updates/new">Bulk Update Users</a> tool to download and update team members with incomplete profiles.
                  </div>
                  <div>
                    Profiles without images must be updated individually unless a default profile picture is set in Manage Team &gt; Team Settings.
                  </div>
                </div>
              ) : (
                <div className={`padding-large rounded-medium ${error ? 'background-light-yellow' : 'background-lightest-green'}`}>
                  {error
                    ? 'There was an error retrieving profile information.'
                    : 'All profiles are complete with the required fields.'}
                </div>
              )
            }
          </div>
        ),
        buttons: [
          {
            label: 'Confirm',
            className: 'confirmation',
            onClick: () => {
              $(this).prop('checked', false);
              saveCompanyFeature(this, value);
            },
          },
          {
            label: 'Cancel',
            onClick: () => {
              $(this).prop('checked', true);
            },
          },
        ],
      });

      $.ajax({
        url: '/admin/bulk_updates/byos_incomplete_profiles',
        success: (data) => showExternalSurveysConfirmAlert(data.show_warning, data.all_incomplete_profiles_count),
        error: () => showExternalSurveysConfirmAlert(undefined, undefined, true),
        dataType: 'json'
      });
    }
  });
});
